(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-index-grid-backup"] && !Shopify.designMode) return;
  try {
    
  class BlogIndex extends HTMLElement {
    constructor() {
      super();
      this.blogHandle = this.dataset.blogHandle;
      this.filterSource = this.dataset.filterSource;
      this.currentTag = this.dataset.currentTag;
      this.currentAuthor = this.dataset.currentAuthor;
      this.searchQuery = this.dataset.searchQuery;

      this.filterChips = [];
      this.searchInput = null;
      this.searchClear = null;
      this.articles = [];
      this.noResultsEl = null;

      this.init();
    }

    init() {
      this.filterChips = Array.from(this.querySelectorAll('[data-filter-chip]'));
      this.searchInput = this.querySelector('[data-search-input]');
      this.searchClear = this.querySelector('[data-search-clear]');
      this.articles = Array.from(this.querySelectorAll('[data-article]'));
      this.noResultsEl = this.querySelector('[data-no-results]');

      this.setupEventListeners();
      this.updateSearchClearVisibility();

      // Apply initial search if query exists
      if (this.searchQuery) {
        this.filterArticles(this.searchQuery);
      }
    }

    setupEventListeners() {
      // Filter chip events
      this.filterChips.forEach(chip => {
        chip.addEventListener('click', (e) => this.handleFilterClick(e));
      });

      // Search events
      if (this.searchInput) {
        this.searchInput.addEventListener('input', (e) => {
          this.handleSearchInput(e.target.value);
        });

        this.searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.clearSearch();
          }
        });
      }

      if (this.searchClear) {
        this.searchClear.addEventListener('click', () => this.clearSearch());
      }
    }

    handleFilterClick(e) {
      const chip = e.target;
      const filterValue = chip.dataset.filterChip;
      const filterType = chip.dataset.filterType;

      // Update URL based on filter
      let url = new URL(window.location);
      url.search = ''; // Clear all params

      if (filterValue) {
        if (filterType === 'tags') {
          url.pathname = url.pathname.replace(/\/tagged\/.*$/, '') + '/tagged/' + encodeURIComponent(filterValue);
        } else if (filterType === 'authors') {
          url.searchParams.set('author', filterValue);
        }
      }

      // Preserve search query
      if (this.searchInput && this.searchInput.value.trim()) {
        url.searchParams.set('q', this.searchInput.value.trim());
      }

      window.location.href = url.toString();
    }

    handleSearchInput(query) {
      this.searchQuery = query.trim();
      this.filterArticles(this.searchQuery);
      this.updateSearchClearVisibility();
      this.updateURL();
    }

    filterArticles(query) {
      if (!query) {
        // Show all articles
        this.articles.forEach(article => {
          article.style.display = '';
        });
        this.noResultsEl.style.display = 'none';
        return;
      }

      const searchTerm = query.toLowerCase();
      let visibleCount = 0;

      this.articles.forEach(article => {
        const title = article.dataset.articleTitle || '';
        const excerpt = article.dataset.articleExcerpt || '';
        const tags = article.dataset.articleTags || '';

        const matches = title.includes(searchTerm) ||
                       excerpt.includes(searchTerm) ||
                       tags.includes(searchTerm);

        if (matches) {
          article.style.display = '';
          visibleCount++;
        } else {
          article.style.display = 'none';
        }
      });

      // Show/hide no results message
      if (visibleCount === 0) {
        this.noResultsEl.style.display = 'block';
      } else {
        this.noResultsEl.style.display = 'none';
      }
    }

    clearSearch() {
      if (this.searchInput) {
        this.searchInput.value = '';
        this.searchQuery = '';
        this.filterArticles('');
        this.updateSearchClearVisibility();
        this.updateURL();
        this.searchInput.focus();
      }
    }

    updateSearchClearVisibility() {
      if (!this.searchClear) return;

      if (this.searchInput && this.searchInput.value.trim()) {
        this.searchClear.classList.add('blog-index-grid__search-clear--visible');
      } else {
        this.searchClear.classList.remove('blog-index-grid__search-clear--visible');
      }
    }

    updateURL() {
      const url = new URL(window.location);

      if (this.searchQuery) {
        url.searchParams.set('q', this.searchQuery);
      } else {
        url.searchParams.delete('q');
      }

      // Update URL without page reload
      window.history.replaceState({}, '', url.toString());
    }
  }

  customElements.define('blog-index', BlogIndex);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    if (!header) return;

    const mobileToggle = header.querySelector('.header__mobile-toggle');
    const mobileMenu = header.querySelector('.header__mobile-menu');
    const colorScheme = header.dataset.colorScheme;
    const desktopNav = header.querySelector('.header__nav--desktop');
    const desktopLogo = desktopNav ? desktopNav.querySelector('.header__logo') : null;

    // Setup mobile menu functionality
    if (mobileToggle && mobileMenu) {
      mobileToggle.addEventListener('click', () => {
        const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';

        mobileToggle.setAttribute('aria-expanded', !isOpen);
        mobileMenu.classList.toggle('active', !isOpen);

        // Prevent body scroll when menu is open
        document.body.style.overflow = !isOpen ? 'hidden' : '';
      });

      // Close menu when clicking outside
      mobileMenu.addEventListener('click', (e) => {
        if (e.target === mobileMenu) {
          closeMobileMenu();
        }
      });

      // Close menu on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
          closeMobileMenu();
        }
      });

      function closeMobileMenu() {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    balanceDesktopMenu();

    window.addEventListener('load', balanceDesktopMenu);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(balanceDesktopMenu).catch(() => {
        /* Ignore font loading errors */
      });
    }

    let balanceResizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(balanceResizeTimeout);
      balanceResizeTimeout = setTimeout(balanceDesktopMenu, 150);
    });

    // Setup auto color scheme functionality
    if (colorScheme === 'auto') {
      detectBackgroundColor();

      // Re-detect on scroll (throttled)
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            detectBackgroundColor();
            ticking = false;
          });
          ticking = true;
        }
      });
    }

    function balanceDesktopMenu() {
      if (!desktopNav || !desktopLogo) return;

      desktopNav.style.paddingLeft = '';
      desktopNav.style.paddingRight = '';

      if (window.innerWidth <= 1100) {
        return;
      }

      const headerRect = header.getBoundingClientRect();
      const logoRect = desktopLogo.getBoundingClientRect();

      if (!headerRect.width || !logoRect.width) {
        return;
      }

      const headerCenter = headerRect.left + headerRect.width / 2;
      const logoCenter = logoRect.left + logoRect.width / 2;
      const offset = headerCenter - logoCenter;

      if (Math.abs(offset) < 1) {
        return;
      }

      if (offset > 0) {
        desktopNav.style.paddingLeft = `${offset}px`;
      } else {
        desktopNav.style.paddingRight = `${Math.abs(offset)}px`;
      }
    }

    function detectBackgroundColor() {
      const firstSection = document.querySelector('main > section:first-child');
      if (!firstSection) return;

      const rect = firstSection.getBoundingClientRect();
      const headerRect = header.getBoundingClientRect();

      // Check if header overlaps with first section
      if (rect.top < headerRect.bottom && rect.bottom > headerRect.top) {
        // Check if section has a data-scheme attribute
        const sectionScheme = firstSection.dataset.scheme;

        if (sectionScheme === 'dark') {
          applyScheme('light'); // Light text on dark background
        } else if (sectionScheme === 'light') {
          applyScheme('dark'); // Dark text on light background
        } else {
          // Fallback: detect background color
          const bgColor = window.getComputedStyle(firstSection).backgroundColor;
          const isDark = isColorDark(bgColor);
          applyScheme(isDark ? 'light' : 'dark');
        }
      }
    }

    function applyScheme(scheme) {
      header.classList.remove('header--light', 'header--dark');
      header.classList.add(`header--${scheme}`);

      // Update logo visibility
      updateLogoVisibility(scheme);
    }

    function updateLogoVisibility(scheme) {
      const lightLogo = header.querySelector('.header__logo-image--light');
      const darkLogo = header.querySelector('.header__logo-image--dark');

      if (!lightLogo && !darkLogo) return;

      if (scheme === 'light') {
        // Show light logo on light backgrounds
        if (lightLogo) lightLogo.style.opacity = '1';
        if (darkLogo) darkLogo.style.opacity = '0';
      } else {
        // Show dark logo on dark backgrounds
        if (lightLogo) lightLogo.style.opacity = '0';
        if (darkLogo) darkLogo.style.opacity = '1';
      }
    }

    function isColorDark(color) {
      // Convert RGB color to brightness value
      const rgb = color.match(/\d+/g);
      if (!rgb) return false;

      const brightness = (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000;
      return brightness < 128;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-grid-9"] && !Shopify.designMode) return;
  try {
    
  class PortfolioGrid extends HTMLElement {
    constructor() {
      super();
      this.pauseOffscreen = this.dataset.pauseOffscreen === 'true';
      this.videos = [];
      this.intersectionObserver = null;
    }

    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('[data-video-element]'));
      this.setupLazyLoading();
      this.setupPauseOffscreen();
    }

    setupLazyLoading() {
      this.videos.forEach(video => {
        if (video.getAttribute('preload') !== 'none') return;
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              video.load();
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 });
        observer.observe(video);
      });
    }

    setupPauseOffscreen() {
      if (!this.pauseOffscreen || this.videos.length === 0) return;
      this.intersectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target.querySelector('[data-video-element]');
          if (!video) return;
          if (entry.isIntersecting) {
            if (video.autoplay && video.paused) {
              video.play().catch(() => {});
            }
          } else {
            if (!video.paused) {
              video.pause();
            }
          }
        });
      }, { threshold: 0.5 });

      this.querySelectorAll('[data-video-container]').forEach(container => {
        this.intersectionObserver.observe(container);
      });
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }
  }

  customElements.define('portfolio-grid', PortfolioGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-snap"] && !Shopify.designMode) return;
  try {
    
  class PortfolioSnap extends HTMLElement {
    constructor() {
      super();

      this.slides = Array.from(this.children).filter((child) =>
        child.classList.contains('portfolio-snap__panel') ||
        child.classList.contains('portfolio-snap__panel-link')
      );
      this.dots = Array.from(this.querySelectorAll('.portfolio-snap__dot'));
      this.previousButton = this.querySelector('[data-slide-direction="previous"]');
      this.nextButton = this.querySelector('[data-slide-direction="next"]');
      this.currentPanel = 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayDelay = Math.max(1, Number(this.dataset.autoplaySeconds) || 5) * 1000;
      this.autoplayTimer = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      this.init();
    }

    init() {
      if (this.slides.length === 0) return;

      this.slides.forEach((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', (index + 1) + ' of ' + this.slides.length);
      });

      this.showSlide(0);
      this.setupControls();
      this.setupPauseBehavior();
      this.startAutoplay();
    }

    setupControls() {
      if (this.previousButton) {
        this.previousButton.addEventListener('click', () => {
          this.showSlide(this.currentPanel - 1);
          this.restartAutoplay();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.showSlide(this.currentPanel + 1);
          this.restartAutoplay();
        });
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.showSlide(index);
          this.restartAutoplay();
        });
      });

      this.addEventListener('keydown', this.handleKeydown);
    }

    setupPauseBehavior() {
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.startAutoplay();
      });

      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.showSlide(this.currentPanel - 1);
        this.restartAutoplay();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.showSlide(this.currentPanel + 1);
        this.restartAutoplay();
      }
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    }

    showSlide(index) {
      if (this.slides.length === 0) return;

      const normalizedIndex = (index + this.slides.length) % this.slides.length;
      this.currentPanel = normalizedIndex;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === normalizedIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if ('inert' in slide) slide.inert = !isActive;

        slide.querySelectorAll('video').forEach((video) => {
          if (isActive) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      });

      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === normalizedIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    startAutoplay() {
      this.stopAutoplay();

      if (
        !this.autoplayEnabled ||
        this.slides.length < 2 ||
        this.motionQuery.matches ||
        document.hidden
      ) return;

      this.autoplayTimer = window.setInterval(() => {
        this.showSlide(this.currentPanel + 1);
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    restartAutoplay() {
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.removeEventListener('keydown', this.handleKeydown);
    }
  }

  if (!customElements.get('portfolio-snap')) {
    customElements.define('portfolio-snap', PortfolioSnap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-slider"] && !Shopify.designMode) return;
  try {
    
  class PressSlider extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.autoplayTimer = null;
      this.isAutoplay = this.dataset.autoplay === 'true';
      this.autoplayInterval = parseInt(this.dataset.autoplayInterval) || 5000;
      this.sliderId = this.dataset.sliderId;

      this.init();
    }

    init() {
      this.slides = this.querySelectorAll('.press-slider__slide');
      this.dots = this.querySelectorAll('.press-slider__dot');
      this.prevButton = this.querySelector('.press-slider__arrow--prev');
      this.nextButton = this.querySelector('.press-slider__arrow--next');

      if (this.slides.length <= 1) return;

      this.setupEventListeners();
      this.updateSlider();

      if (this.isAutoplay) {
        this.startAutoplay();
        this.setupAutoplayPauseOnHover();
      }
    }

    setupEventListeners() {
      // Dot navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Arrow navigation
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });

      // Touch/swipe support
      this.setupTouchEvents();
    }

    setupTouchEvents() {
      let startX = 0;
      let startY = 0;
      let distX = 0;
      let distY = 0;
      const threshold = 50;

      this.addEventListener('touchstart', (e) => {
        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
      });

      this.addEventListener('touchmove', (e) => {
        if (!startX || !startY) return;

        const touch = e.touches[0];
        distX = touch.clientX - startX;
        distY = touch.clientY - startY;
      });

      this.addEventListener('touchend', () => {
        if (!startX || !startY) return;

        // Only trigger if horizontal swipe is greater than vertical
        if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > threshold) {
          if (distX > 0) {
            this.prevSlide();
          } else {
            this.nextSlide();
          }
        }

        // Reset
        startX = 0;
        startY = 0;
        distX = 0;
        distY = 0;
      });
    }

    setupAutoplayPauseOnHover() {
      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.pauseAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;

      this.currentSlide = index;
      this.updateSlider();

      if (this.isAutoplay) {
        this.resetAutoplay();
      }
    }

    nextSlide() {
      const nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    updateSlider() {
      // Update slides
      this.slides.forEach((slide, index) => {
        const isActive = index === this.currentSlide;
        slide.classList.toggle('press-slider__slide--active', isActive);

        if (isActive) {
          slide.style.display = 'block';
          slide.style.opacity = '1';
          slide.style.position = 'relative';
          slide.style.pointerEvents = 'auto';
        } else {
          slide.style.display = 'none';
          slide.style.opacity = '0';
          slide.style.position = 'absolute';
          slide.style.pointerEvents = 'none';
        }
      });

      // Update dots
      this.dots.forEach((dot, index) => {
        const isActive = index === this.currentSlide;
        dot.classList.toggle('press-slider__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive);
      });

      // Update arrows
      if (this.prevButton) {
        this.prevButton.disabled = this.currentSlide === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentSlide === this.slides.length - 1;
      }
    }

    startAutoplay() {
      if (!this.isAutoplay || this.slides.length <= 1) return;

      this.pauseAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, this.autoplayInterval);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    resetAutoplay() {
      if (this.isAutoplay) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.pauseAutoplay();
    }
  }

  if (!customElements.get('press-slider')) {
    customElements.define('press-slider', PressSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSlider extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.autoplayTimer = null;
      this.isAutoplay = this.dataset.autoplay === 'true';
      this.autoplayInterval = parseInt(this.dataset.autoplayInterval) || 6000;
      this.sliderId = this.dataset.sliderId;

      this.init();
    }

    init() {
      this.slides = this.querySelectorAll('.t-slider__slide');
      this.dots = this.querySelectorAll('.t-slider__dot');
      this.prevButton = this.querySelector('.t-slider__arrow--prev');
      this.nextButton = this.querySelector('.t-slider__arrow--next');

      if (this.slides.length <= 1) return;

      this.setupEventListeners();
      this.updateSlider();

      if (this.isAutoplay) {
        this.startAutoplay();
        this.setupAutoplayPauseOnHover();
      }
    }

    setupEventListeners() {
      // Dot navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Arrow navigation
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });

      // Touch/swipe support
      this.setupTouchEvents();
    }

    setupTouchEvents() {
      let startX = 0;
      let startY = 0;
      let distX = 0;
      let distY = 0;
      const threshold = 50;

      this.addEventListener('touchstart', (e) => {
        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
      });

      this.addEventListener('touchmove', (e) => {
        if (!startX || !startY) return;

        const touch = e.touches[0];
        distX = touch.clientX - startX;
        distY = touch.clientY - startY;
      });

      this.addEventListener('touchend', () => {
        if (!startX || !startY) return;

        // Only trigger if horizontal swipe is greater than vertical
        if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > threshold) {
          if (distX > 0) {
            this.prevSlide();
          } else {
            this.nextSlide();
          }
        }

        // Reset
        startX = 0;
        startY = 0;
        distX = 0;
        distY = 0;
      });
    }

    setupAutoplayPauseOnHover() {
      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.pauseAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;

      this.currentSlide = index;
      this.updateSlider();

      if (this.isAutoplay) {
        this.resetAutoplay();
      }
    }

    nextSlide() {
      const nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    updateSlider() {
      if (!this.slides || this.slides.length === 0) return;

      // Update slides
      this.slides.forEach((slide, index) => {
        const isActive = index === this.currentSlide;

        if (isActive) {
          slide.classList.add('t-slider__slide--active');
          slide.style.display = 'block';
          slide.style.opacity = '1';
          slide.style.position = 'relative';
          slide.style.pointerEvents = 'auto';
          slide.style.visibility = 'visible';
        } else {
          slide.classList.remove('t-slider__slide--active');
          slide.style.display = 'none';
          slide.style.opacity = '0';
          slide.style.position = 'absolute';
          slide.style.pointerEvents = 'none';
          slide.style.visibility = 'hidden';
        }
      });

      // Update dots
      if (this.dots) {
        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentSlide;

          if (isActive) {
            dot.classList.add('t-slider__dot--active');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.classList.remove('t-slider__dot--active');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      }

      // Update arrows
      if (this.prevButton) {
        this.prevButton.disabled = this.currentSlide === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentSlide === this.slides.length - 1;
      }
    }

    startAutoplay() {
      if (!this.isAutoplay || this.slides.length <= 1) return;

      this.pauseAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, this.autoplayInterval);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    resetAutoplay() {
      if (this.isAutoplay) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.pauseAutoplay();
    }
  }

  customElements.define('testimonials-slider', TestimonialsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-variant-b"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsVariantB extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.autoplayTimer = null;
      this.isAutoplay = this.dataset.autoplay === 'true';
      this.autoplayInterval = parseInt(this.dataset.autoplayInterval) || 6000;
      this.showNav = this.dataset.showNav === 'true';
      this.sliderId = this.dataset.sliderId;

      this.init();
    }

    init() {
      this.slides = this.querySelectorAll('.testimonials-b__slide');
      this.dots = this.querySelectorAll('.testimonials-b__dot');
      this.prevButton = this.querySelector('.testimonials-b__nav-button--prev');
      this.nextButton = this.querySelector('.testimonials-b__nav-button--next');

      if (this.slides.length <= 1) return;

      this.setupEventListeners();
      this.updateSlider();

      if (this.isAutoplay && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        this.startAutoplay();
        this.setupAutoplayPauseOnHover();
      }
    }

    setupEventListeners() {
      // Dot navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Arrow navigation
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prevSlide();
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Touch/swipe support
      this.setupTouchEvents();
    }

    setupTouchEvents() {
      let startX = 0;
      let startY = 0;
      let distX = 0;
      let distY = 0;
      const threshold = 50;

      this.addEventListener('touchstart', (e) => {
        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
      }, { passive: true });

      this.addEventListener('touchmove', (e) => {
        if (!startX || !startY) return;

        const touch = e.touches[0];
        distX = touch.clientX - startX;
        distY = touch.clientY - startY;
      }, { passive: true });

      this.addEventListener('touchend', () => {
        if (!startX || !startY) return;

        // Only trigger if horizontal swipe is greater than vertical
        if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > threshold) {
          if (distX > 0) {
            this.prevSlide();
          } else {
            this.nextSlide();
          }
        }

        // Reset
        startX = 0;
        startY = 0;
        distX = 0;
        distY = 0;
      }, { passive: true });
    }

    setupAutoplayPauseOnHover() {
      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.pauseAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;

      console.log(`Going to slide ${index}, current was ${this.currentSlide}`);
      this.currentSlide = index;
      this.updateSlider();

      if (this.isAutoplay) {
        this.resetAutoplay();
      }
    }

    nextSlide() {
      const nextIndex = this.currentSlide < this.slides.length - 1 ?
        this.currentSlide + 1 : 0;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = this.currentSlide > 0 ?
        this.currentSlide - 1 : this.slides.length - 1;
      this.goToSlide(prevIndex);
    }

    updateSlider() {
      if (!this.slides || this.slides.length === 0) return;

      console.log(`Updating slider: currentSlide=${this.currentSlide}, total slides=${this.slides.length}`);

      // Update slides
      this.slides.forEach((slide, index) => {
        const isActive = index === this.currentSlide;
        console.log(`Slide ${index}: isActive=${isActive}`);

        if (isActive) {
          slide.classList.add('testimonials-b__slide--active');
          slide.style.display = 'block';
        } else {
          slide.classList.remove('testimonials-b__slide--active');
          slide.style.display = 'none';
        }
      });

      // Update dots
      if (this.dots) {
        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentSlide;

          if (isActive) {
            dot.classList.add('testimonials-b__dot--active');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.classList.remove('testimonials-b__dot--active');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      }

      // Update navigation buttons - disable at ends for non-looping
      if (this.prevButton) {
        // Enable looping for now, can be changed to disable at ends if desired
        this.prevButton.disabled = false; // this.currentSlide === 0;
      }
      if (this.nextButton) {
        // Enable looping for now, can be changed to disable at ends if desired
        this.nextButton.disabled = false; // this.currentSlide === this.slides.length - 1;
      }
    }

    startAutoplay() {
      if (!this.isAutoplay || this.slides.length <= 1) return;

      this.pauseAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, this.autoplayInterval);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    resetAutoplay() {
      if (this.isAutoplay) {
        this.pauseAutoplay();
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.pauseAutoplay();
    }
  }

  customElements.define('testimonials-variant-b', TestimonialsVariantB);

  } catch(e) { console.error(e); }
})();
})();
